/* istanbul ignore file */
import styled from 'styled-components';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';

export const Div = styled.div`
  flex-direction: column;
  padding-left: 1.5rem;
`;

export const ColumnDiv = styled(Div)`
  flex-direction: column;
`;

export const FlexDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FlexColumnDiv = styled(FlexDiv)`
  flex-direction: column;
`;

export const UserActionsDiv = styled.div`
  flex-direction: column;
  border-left: solid;
  border-left-color: #625E81;
  &:hover {
    background-color: ${({ theme }) => theme.headerHoverColor};
  }
`;

export const InfoDiv = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.infoBackgroundColor};
`;

export const WarningDiv = styled.div`
  background-color: ${({ theme }) => theme.warningBackgroundColor};
`;

export const SubDivComponent = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  background: #D2D1DB;
  border-radius: 4px;
  padding: 8px;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

export const DivComponent = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 15px;
`;

export const Text = styled(Paragraph).attrs({ typography: 'ParagraphXsmallRegular' })`
  ${({ theme }) => theme.fontStyles};
  margin: 0;
`;

export const ScrollableContainerOuter = styled(FlexColumnDiv)`
  overflow-x: hidden;
  position: relative;
  ${({ theme }) => theme.hiddenScrollbarStyles};
`;

export const ScrollableContainerOuterWithVerticalScrollbar = styled(FlexColumnDiv)`
  overflow-x: hidden;
  position: relative;
  overflow-y: auto;
`;

export const ScrollableContainerInner = styled(FlexColumnDiv)`
  position: absolute;
  width: 100%;
`;
